const columns = [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "QrSensor",
    headerName: "QrSensor",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "created_at",
    headerName: "CreatedAt",
    flex: 1,
    minWidth: 150,
    //   editable: true,
  },
  {
    field: "N",
    headerName: "N",
    type: "number",
    flex: 1,
    minWidth: 80,
    //   editable: true,
  },
  {
    field: "P",
    headerName: "P",
    type: "number",
    flex: 1,
    minWidth: 80,
    //   editable: true,
  },
  {
    field: "K",
    headerName: "K",
    type: "number",
    flex: 1,
    minWidth: 80,
    //   editable: true,
  },
  {
    field: "Moist",
    headerName: "Moist",
    type: "number",
    flex: 1,
    minWidth: 80,
    //   editable: true,
  },
  {
    field: "Temperature",
    headerName: "Temperature",
    type: "number",
    flex: 1,
    minWidth: 100,
    //   editable: true,
  },
  {
    field: "EC",
    headerName: "EC",
    type: "number",
    flex: 1,
    minWidth: 80,
    //   editable: true,
  },
  {
    field: "pH",
    headerName: "pH",
    type: "number",
    flex: 1,
    minWidth: 80,
    //   editable: true,
  },
  {
    field: "farm_name",
    headerName: "FarmName",
    type: "number",
    flex: 1,
    minWidth: 150,
    //   editable: true,
  },
  {
    field: "region_name",
    headerName: "RegionName",
    type: "number",
    flex: 1,
    minWidth: 150,
    //   editable: true,
  }
];

// const DeviceColumn = [
//   {
//     field: 'id',
//     headerName: 'id',
//     type: 'number',
//     width: 90,
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//   },
//   {
//     field: 'qr_string',
//     headerName: 'QrCode',
//     minWidth: 150,
//     flex: 1,
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center'
//   },
//   {
//     field: 'device_type',
//     headerName: 'Type',
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     editable: true,
//     flex: 1,
//   },
//   {
//     field: 'status',
//     headerName: 'Status',
//     flex: 1,
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     editable: true,
//   },
//   {
//     field: 'creator',
//     headerName: 'Manager',
//     flex: 1,
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     editable: true,
//   },
//   {
//     field: 'init_at',
//     headerName: 'Init',
//     minWidth: 150,
//     flex: 1,
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     type: "date",
//     editable: true,
//     valueFormatter: ({ value }) => new Intl.DateTimeFormat('vi-VI', {
//       day: '2-digit', month: '2-digit', year: 'numeric',
//   }).format(new Date(value))
//   }
// ,  {
//     field: 'activated_phone',
//     headerName: 'Owner',
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     minWidth: 150,
//     flex: 1,
//   },
//   {
//     field: 'farm_name',
//     headerName: 'Farm',
//     minWidth: 200,
//     flex: 1,
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     editable: true,
//   },
//   {
//     field: 'region_name',
//     headerName: 'Region',
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     minWidth: 200,
//     flex: 1,
//     editable: true,
//   },
//   {
//     field: 'created_at',
//     headerName: 'Activated_at',
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     minWidth: 150,
//     flex: 1,
//   },
//   {
//     field: 'in_depth',
//     headerName: 'Depth',
//     flex: 1,
//     headerClassName: 'super-app-theme--header',
//     headerAlign: 'center',
//     editable: true
//   }
// ]
export {
  columns,
  // DeviceColumn
};
